document.addEventListener("DOMContentLoaded", function () {
    const tabsDelivery = document.querySelector('.tabs-delivery');
    if(tabsDelivery){
        tabsDelivery.addEventListener('click', (e) => {
            const tabDelivery = tabsDelivery.querySelectorAll('.tab-delivery');
            if(tabDelivery.length){
                tabDelivery.forEach(tab => {
                    const input = tab.querySelector('.custom-radio__input')
                    if (input.checked) {
                        tab.classList.add("tab-delivery--checked");
                    }else{
                        tab.classList.remove("tab-delivery--checked");
                    }
                })
            }     
        })
    }
});